import { Component, OnInit, Input, forwardRef, OnDestroy } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  AbstractControl,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  ControlValueAccessor,
  Validator,
  ValidationErrors
} from '@angular/forms';
import { DateValuesGenerator } from './date-values-generator';
import { Subscription } from 'rxjs';
import { ErrorMessage } from 'src/app/shared/reactive-validators/error.message';
import { BaseFormComponent } from '../../base-form.component';
import { CommonFunctions } from '../../../common/common-functions';

@Component({
  selector: 'app-date-control',
  templateUrl: './date-control.component.html',
  styleUrls: ['./date-control.component.scss'],
  standalone: false,
  providers: [
    {
   provide: NG_VALUE_ACCESSOR,
   useExisting: forwardRef(() => DateControlComponent),
   multi: true
 },
  {
   provide: NG_VALIDATORS,
   useExisting: forwardRef(() => DateControlComponent),
   multi: true
 }
]
})
export class DateControlComponent extends BaseFormComponent implements OnInit, OnDestroy, ControlValueAccessor, Validator {
  @Input() numberOfPastYear = 100;
  @Input() numberOfFutureYear = 0;
  @Input() forBirthdate = true;
  @Input() controlMonthId = 'controlMonthId';
  @Input() controlDateId = 'controlDateId';
  @Input() controlYearId = 'controlYearId';
  @Input() FIELD_SPACING: number;
  @Input() LABEL_SPACING: number;  
  // @Input() watchDate: FormControl;

  errorMessage: string = ErrorMessage.dateOfBirthMsg;
  subscriptions: Subscription[] = [];
  months: any[];
  days: number[];
  years: any[];

  public dateControlForm: UntypedFormGroup;
  constructor(private commonFunctions: CommonFunctions) { super(commonFunctions); }

  ngOnInit() {
    this.dateControlForm = new UntypedFormGroup({
      month: new UntypedFormControl('0'),
      date: new UntypedFormControl('0'),
      year: new UntypedFormControl('0'),
    });
    this.months = DateValuesGenerator.returnMonths();
    this.years = DateValuesGenerator.returnYears(this.numberOfPastYear, this.numberOfFutureYear);
    this.onChanges();
  }

  onChanges(): void {
    this.subscriptions.push(
      this.dateControlForm.get('year').valueChanges.subscribe(val => {
        const currentDate = new Date();
        const month = this.dateControlForm.get('month').value.toString();
        this.days = DateValuesGenerator.returnDays(`${val}-${String('0' + month.toString().trim()).slice(-2)}`);
        this.months = DateValuesGenerator.returnMonths();
        // no future month and day for birthday
        if (val.toString() === currentDate.getFullYear().toString() && this.forBirthdate) {
          setTimeout(() => {
            this.months = DateValuesGenerator.returnPrevMonths(currentDate.getMonth());
          });
          if (month === (currentDate.getMonth() + 1).toString()) {
            setTimeout(() => {
              this.days = DateValuesGenerator
              .returnPrevDays(`${val}-${String('0' + month.toString().trim()).slice(-2)}`, currentDate.getDate());
            });
          }
        }
      })
    );

    this.subscriptions.push(
      this.dateControlForm.get('month').valueChanges.subscribe(val => {
        const currentDate = new Date();
        const year = this.dateControlForm.get('year').value.toString();
        this.days = DateValuesGenerator.returnDays(`${year}-${String('0' + val.toString().trim()).slice(-2)}`);
        // no future day for birthday
        if (year === currentDate.getFullYear().toString() && val.toString() === (currentDate.getMonth() + 1).toString()
            && this.forBirthdate) {
          setTimeout(() => {
            this.days =
            DateValuesGenerator.returnPrevDays(`${year}-${String('0' + val.toString().trim()).slice(-2)}`, currentDate.getDate());
          });
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }
  private unsubscribeAll() {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
  }
  public onTouched: () => void = () => {};

  writeValue(value: any): void {
    if (value !== '' && value !== 'undefined' && value != null) {
      if (value.year > 0 && value.month > 0 && value.date > 0 ) {
        setTimeout(() => {
          this.dateControlForm.get('year').setValue(value.year);
        });
        setTimeout(() => {
          this.dateControlForm.get('month').setValue(value.month);
        });
        setTimeout(() => {
          this.dateControlForm.get('date').setValue(value.date);
        });
      }
    } else {
      setTimeout(() => {
        this.dateControlForm.get('year').setValue('0');
      });
      setTimeout(() => {
        this.dateControlForm.get('month').setValue('0');
      });
      setTimeout(() => {
        this.dateControlForm.get('date').setValue('0');
      });
    }
  }
  registerOnChange(fn: any): void {
    this.subscriptions.push(this.dateControlForm.valueChanges.subscribe(fn));
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.dateControlForm.disable() : this.dateControlForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null {
    const isRequired = this.hasRequiredFieldValidation(c);
    // console.log('[Date Control] required validation', isRequired);
    // console.log('[Date Control] validator', c.validator);
    // console.log('[Date Control] form valid', this.dateControlForm.valid);
    if ( c.validator &&  isRequired) {
      return (this.dateControlForm.valid &&
        this.dateControlForm.get('year').value !== '0' &&
        this.dateControlForm.get('month').value !== '0' &&
        this.dateControlForm.get('date').value !== '0')
         ? null : { invalidForm: {valid: false, message: this.errorMessage }};
    } else {
      return (this.dateControlForm.valid)
         ? null : { invalidForm: {valid: false, message: 'dateControlForm fields are invalid'}};
    }
  }

  hasRequiredFieldValidation(c: AbstractControl): boolean {
    if (c.validator) {
      const validator = c.validator({}as AbstractControl);
      if (validator && validator.required) {
          return true;
      }
    }
    return false;
  }

  private UpdateValidateDateOfBirthIE11(control: AbstractControl): void {
    console.log('[Contact info] validating for IE 11');
    if (control.value.year === 0 || control.value.month === 0 || control.value.date === 0 ||
      control.value.year === '0' || control.value.month === '0' || control.value.date === '0') {
      control.setErrors({ invalidForm: {valid: false, message: this.errorMessage }});
    } else {
      control.setErrors(null);
    }
  }
}
